import { BestType } from '@diritto/common/best/constants';
import { RelayType } from '@diritto/common/content/constants';
import { ContentRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { covertToTimeString } from '@diritto/common/utils/date';
import { RankingContentItem } from 'app-components/ranking/RankingContentItem';
import React from 'react';
import { useBlockProfiles } from 'state-hooks/accounts/useBlockProfiles';
import { ContentBodyContainer } from 'ui-components/layout/containers/ContentBodyCenterContainer';

interface RankingContentListProps {
  contentIds: number[];
  contents: Record<number | string, ContentRelayDto>;
  profiles: Record<number | string, ProfileLiteRelayDto>;
  aggregatedAt?: Date;
  bestType: BestType;
  categoryId?: number;
}

export const RankingContentList = ({
  contentIds,
  aggregatedAt,
  contents,
  profiles,
  bestType,
  categoryId,
}: RankingContentListProps) => {
  const blockedProfileIds = useBlockProfiles();

  return (
    <ContentBodyContainer className="flex flex-col items-center justify-center w-full">
      {aggregatedAt && (
        <div className="flex w-full mb-6 text-gray-500 text-xxxs font-medium">
          {covertToTimeString(aggregatedAt)} 기준
        </div>
      )}
      <section className="flex flex-col w-full space-y-4">
        {contentIds.map((id, idx) => {
          const content: ContentRelayDto = contents[id];
          const profile =
            content?.relayType === RelayType.Public && content.profileId ? profiles[content.profileId] : undefined;

          if ((profile && profile.isDeleted) || !content || content.relayType !== RelayType.Public) {
            return null;
          }

          if (profile && blockedProfileIds.has(profile.id)) {
            return null;
          }

          return (
            <RankingContentItem
              key={id}
              listItemIndex={idx}
              bestType={bestType}
              content={content}
              profile={profile}
              selectedCategoryId={categoryId}
            />
          );
        })}
      </section>
    </ContentBodyContainer>
  );
};
